import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ShowHavePermissionDirective } from '../../../core/directives/show-have-permission.directive';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoginService } from '../../../core/services/login/login.service';
import { User, UserDetail, ActionContext } from '../../../core/models/user.models';
import { CapitalizePipe } from '../../../core/pipes/capitalize.pipe';
import { HelpService } from '../../../core/services/help/help.service';
import { FadeIn } from '../../../core/animations';
import { MediaQueryModule } from '../../directives/media-querys/media-query.module';
import { PlatformServices } from '../../../core/services/platform/platform.service';
import { MatDialog } from '@angular/material/dialog';
import { ActionsDialogComponent } from '../../../pages/configuration-profile/actions-dialog/actions-dialog.component';
import { UserService } from '../../../core/services/user/user.service';
import { EnvService } from '../../services/env.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    ShowHavePermissionDirective,
    MatMenuModule,
    FontAwesomeModule,
    CapitalizePipe,
    RouterModule,
    MediaQueryModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [FadeIn(1000, false)]

})
export class HeaderComponent {
  @Input() isSidebarOpen = false;

  @ViewChild('menuMobile', { static: false }) menu!: ElementRef;

  isMenuOpen = false;

  isHelpOpen: boolean = false;

  menuHelp = false;

  menuConfiguration = false;

  menuPrivacity = false;

  currentScreen: string = '';

  configurationStyles = this.envService.getConfigurationStyles();

  constructor(
    private router: Router,
    private loginService: LoginService,
    private helpDialogService: HelpService,
    private renderer: Renderer2,
    private platform: PlatformServices,
    private dialog: MatDialog,
    private userService: UserService,
    private envService: EnvService
  ) {

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isMenuOpen = false;
      }
    });
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.isMenuOpen && this.menu.nativeElement && !this.menu.nativeElement?.contains(e.target)) {
        this.isMenuOpen = false;
      }
    });
    this.currentScreen = this.platform.currentScreenSize;
  }


  fistName: string = '';
  lastName: string = '';
  speciality: string = '';
  userId!: number;

  ngOnInit() {
    if (sessionStorage.getItem('user')) {
      const user: User = JSON.parse(sessionStorage.getItem('user') ?? '');
      if (user) {
        this.userId = user.id;
        this.fistName = user.firstName;
        this.lastName = user.lastName;
        this.speciality = user?.speciality?.description ?? '';
      }
    }
  }

  openMenu(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.isMenuOpen = !this.isMenuOpen;
  }

  helpOptions() {
    this.isHelpOpen = !this.isHelpOpen;
  }

  redirect(item: string) {
    this.loginService.logout();
    this.router.navigate(['/login'])
  }

  openHelp() {
    this.isMenuOpen = false;
    this.helpDialogService.showHelp();
  }

  openCookies() {
    this.isMenuOpen = false;
    this.helpDialogService.showCookies();
  }

  openProfile() {
    this.userService.getById(this.userId).subscribe((userDetail: UserDetail) => {
      let dialogSeetings;
      if(this.currentScreen === 'Web') {
        dialogSeetings = {
          width: "800px",
          position: { top: '5%' },
          data: {isActive: userDetail.active, user: userDetail, mode: "update", context: ActionContext.PROFILE}
        }
      } else {
        dialogSeetings = {
          height: "calc(100% - 85px)",
          width: "100%",
          maxWidth: "100%",
          position: { top: '85px' },
          data: {isActive: userDetail.active, user: userDetail, mode: "update", context: ActionContext.PROFILE}
        }

      }

      this.dialog.open( ActionsDialogComponent, dialogSeetings);
    });

  }

  changeMenuHelp() {
    this.menuHelp = !this.menuHelp;
    this.menuPrivacity = false;
  }

  changeMenuCookies() {
    this.menuHelp = false;
    this.menuPrivacity = !this.menuPrivacity;

  }

  changeMenus(menuId: string) {
    switch (menuId) {
      case "help": {
        this.menuHelp = !this.menuHelp;
        break;
      }
      case "configuration": {
        this.menuConfiguration = !this.menuConfiguration;
        break;
      }
    }

  }

  goHome() {
    this.router.navigate(['/home'], { onSameUrlNavigation: 'reload' });
  }


  navigate(url: string) {
    this.router.navigate([url], { onSameUrlNavigation: 'reload' });

  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

}
